/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'security';

export const authProfileModalBreadcrumbTitle = `${prefix}.authProfileModalBreadcrumbTitle`;

export const ENGLISH = {
    [authProfileModalBreadcrumbTitle]: 'Auth Profile',
};
